import ApiService from '@/common/api.service'

import {
  CREATE_CLUB,
  INVALID_CLUB_LOGO,
  GET_CLUBS,
  GET_CLUB,
  DELETE_CLUB,
  UPDATE_CLUB,
  RESET_CLUB_STATE
} from './actions.type'
import {
  SET_IS_LOADING,
  SET_ERROR,
  SET_CREATED_CLUB,
  SET_CLUBS,
  SET_CLUB,
  SET_UPDATED_CLUB,
  RESET_STATE
} from './mutations.type'

export const getDefaultState = () => {
  return {
    totalClubs: [],
    isLoading: false,
    clubLogoUrl: null,
    club: null,
    error: null,
    totalPage: 1
  }
}

const state = getDefaultState()

const getters = {

}

const actions = {
  [INVALID_CLUB_LOGO](context) {
    context.commit(SET_ERROR, { message: 'Please select a 128px X 128px image size!' })
  },
  [CREATE_CLUB](context, club) {
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.post('api/v1/clubs', club)
        .then(({ data }) => {
          context.commit(SET_CREATED_CLUB, data)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response)
        })
    })
  },
  [GET_CLUBS](context) {
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.get('api/v1/clubs')
        .then(({ data }) => {
          context.commit(SET_CLUBS, data)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response)
        })
    })
  },
  [GET_CLUB](context, id) {
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.get(`api/v1/clubs/${id}`)
        .then(({ data }) => {
          context.commit(SET_CLUB, data)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [UPDATE_CLUB](context, club) {
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.put(`api/v1/clubs/${club.id}`, { clubName: club.clubName, avatar: club.avatar })
        .then(({ data }) => {
          context.commit(SET_UPDATED_CLUB, data)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [DELETE_CLUB](context, club) {
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.delete(`api/v1/clubs/${club.id}`)
        .then(({ data }) => {
          context.commit(SET_CLUBS, club)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response)
        })
    })
  },
  [RESET_CLUB_STATE](context) {
    context.commit(RESET_STATE)
  }
}

const mutations = {
  [SET_CREATED_CLUB](state, response) {
    state.clubLogoUrl = ''
    state.club = null
    state.isLoading = false
  },
  [SET_CLUBS](state, response) {
    if (Array.isArray(response) && response) {
      state.totalClubs = response
      if (response.length > 10) {
        state.totalPage = Math.ceil(response.length / 10)
      }
    } else {
      state.totalClubs.splice(state.totalClubs.indexOf(response), 1)
      if (state.totalClubs) {
        if (state.totalClubs.length > 10) {
          state.totalPage = Math.ceil(state.totalClubs.length / 10)
        }
      }
    }
    state.isLoading = false
    state.error = null
  },
  [SET_UPDATED_CLUB](state, response) {
    for (let i in state.totalClubs) {
      if (state.totalClubs[i].id === response.id) {
        state.totalClubs[i] = response
      }
    }
    state.isLoading = false
    state.error = null
  },
  [SET_CLUB](state, response) {
    state.club = response
    state.isLoading = false
    state.error = null
  },
  [SET_ERROR](state, error) {
    state.error = error
    state.isLoading = false
  },
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
